import React, { useState } from "react";

export const competitionLogoSrc = (competition) =>
  competition?.logo_url
    ? `${process.env.REACT_APP_BACKEND_URL}/api/public/files/${competition.logo_url}`
    : null;

export function CompetitionLogo({ competition, height = 48, className = "", fallback = null, testId = "competition-logo" }) {
  const [broken, setBroken] = useState(false);
  const src = competitionLogoSrc(competition);
  if (!src || broken) return fallback;
  return (
    <img
      data-testid={testId}
      src={src}
      alt={competition?.nome || "Logo do campeonato"}
      className={`object-contain ${className}`}
      style={{ height, maxWidth: height * 3 }}
      onError={() => setBroken(true)}
    />
  );
}
